import type { ApolloError } from '@apollo/client';

import { isGraphQLAuthError } from 'src/modules/error-handling/error-handling';

import { Actions, type SummaryAction } from './actions';

export const updateSummarySuccess = (): SummaryAction => ({
  type: Actions.SUMMARY_UPDATE_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const updateSummaryFailure = (error: ApolloError): SummaryAction => ({
  type: Actions.SUMMARY_UPDATE_FAILURE,
  payload: { error },
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const updateSummary = (newSummary: string): SummaryAction => ({
  type: Actions.SUMMARY_UPDATE_START,
  payload: {
    newSummary,
  },
});
